"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVersionForTeamsAppYamlFile = exports.createDriverContext = exports.mapStateToEnv = exports.loadStateFromEnv = void 0;
const tslib_1 = require("tslib");
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const path_1 = tslib_1.__importDefault(require("path"));
const yaml_1 = require("yaml");
const globalVars_1 = require("../../../common/globalVars");
const versionMetadata_1 = require("../../../common/versionMetadata");
// Needs to validate the parameters outside of the function
function loadStateFromEnv(outputEnvVarNames) {
    const result = {};
    for (const [propertyName, envVarName] of outputEnvVarNames) {
        result[propertyName] = process.env[envVarName];
    }
    return result;
}
exports.loadStateFromEnv = loadStateFromEnv;
// Needs to validate the parameters outside of the function
function mapStateToEnv(state, outputEnvVarNames, excludedProperties) {
    const result = new Map();
    for (const [outputName, envVarName] of outputEnvVarNames) {
        if (!(excludedProperties === null || excludedProperties === void 0 ? void 0 : excludedProperties.includes(outputName))) {
            result.set(envVarName, state[outputName]);
        }
    }
    return result;
}
exports.mapStateToEnv = mapStateToEnv;
function createDriverContext(inputs) {
    const driverContext = {
        azureAccountProvider: globalVars_1.TOOLS.tokenProvider.azureAccountProvider,
        m365TokenProvider: globalVars_1.TOOLS.tokenProvider.m365TokenProvider,
        ui: globalVars_1.TOOLS.ui,
        progressBar: undefined,
        logProvider: globalVars_1.TOOLS.logProvider,
        telemetryReporter: globalVars_1.TOOLS.telemetryReporter,
        projectPath: inputs.projectPath,
        platform: inputs.platform,
    };
    return driverContext;
}
exports.createDriverContext = createDriverContext;
async function updateVersionForTeamsAppYamlFile(projectPath) {
    for (const yamlFileName of versionMetadata_1.YamlFileNames) {
        const ymlPath = path_1.default.join(projectPath, yamlFileName);
        if (await fs_extra_1.default.pathExists(ymlPath)) {
            const ymlContent = await fs_extra_1.default.readFile(ymlPath, "utf-8");
            const document = (0, yaml_1.parseDocument)(ymlContent);
            const version = document.get("version");
            if (version <= "v1.7") {
                if (version <= "v1.6") {
                    convertOutputJsonPathToOutputFolder(document);
                }
                if (version === "v1.3") {
                    renameClientSecret(document);
                }
                document.set("version", "v1.8");
                const docContent = document.toString();
                // yaml-language-server can be like https://aka.ms/teams-toolkit/1.0.0/yaml.schema.json and https://aka.ms/teams-toolkit/v1.2/yaml.schema.json
                const updatedContent = docContent.replace(/(yaml-language-server:\s*\$schema=https:\/\/aka\.ms\/teams-toolkit\/)(v?\d+\.\d+(?:\.\d+)?)(\/yaml\.schema\.json)/, "$1v1.8$3");
                await fs_extra_1.default.writeFile(ymlPath, updatedContent, "utf8");
            }
        }
    }
}
exports.updateVersionForTeamsAppYamlFile = updateVersionForTeamsAppYamlFile;
function processSectionsByUse(document, targetUseValue, processor) {
    const sections = ["provision", "publish"];
    sections.forEach((sectionKey) => {
        const section = document.get(sectionKey, true);
        if (section && Array.isArray(section.items)) {
            section.items.forEach((item) => {
                var _a;
                if (item && ((_a = item.get("uses", true)) === null || _a === void 0 ? void 0 : _a.value) === targetUseValue) {
                    const withNode = item.get("with", true);
                    if (withNode) {
                        processor(withNode);
                    }
                }
            });
        }
    });
}
function convertOutputJsonPathToOutputFolder(document) {
    processSectionsByUse(document, "teamsApp/zipAppPackage", (withNode) => {
        var _a;
        const outputJsonPath = (_a = withNode.get("outputJsonPath", true)) === null || _a === void 0 ? void 0 : _a.value;
        if (typeof outputJsonPath === "string") {
            withNode.set("outputFolder", path_1.default.dirname(outputJsonPath));
            withNode.delete("outputJsonPath");
        }
    });
}
function renameClientSecret(document) {
    processSectionsByUse(document, "apiKey/register", (withNode) => {
        var _a;
        const secretValue = (_a = withNode.get("clientSecret", true)) === null || _a === void 0 ? void 0 : _a.value;
        if (typeof secretValue === "string") {
            withNode.set("primaryClientSecret", secretValue);
            withNode.delete("clientSecret");
        }
    });
}
//# sourceMappingURL=utils.js.map